import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IStockMovement, IStockMovementInput } from "@/interfaces/sku-movement.interfaces";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class StockMovementService {
  private baseUrl = "api/v1/stockmovement";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IStockMovement>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const skuMovements = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return skuMovements;
  }

  async filter(
    filter: IFilter<IStockMovement>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IStockMovement>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async getById(skuMovementId: number, accessToken?: string): Promise<IStockMovement> {
    const config = accessToken
      ? { headers: { Authorization: `Bearer ${accessToken}` } }
      : undefined;

    const skuMovement = await httpRequest.get(`${this.baseUrl}/${skuMovementId}`, config);

    return skuMovement;
  }

  async create(formData: IStockMovementInput): Promise<IStockMovement> {
    const skuMovement = await httpRequest.post(this.baseUrl, formData);
    return skuMovement;
  }

  async update(formData: IStockMovementInput, skuMovementId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${skuMovementId}`, formData);
  }

  async delete(skuMovementId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${skuMovementId}`);
  }
}

const stockMovementService = new StockMovementService();
export default stockMovementService;
